import { useEffect, useState } from 'react';

/**
 * O valor, só depois de ele parar de mudar por `delayMs`. Evita uma busca no
 * servidor a cada tecla.
 */
export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);
  return debounced;
}
